import {redirect} from "react-router-dom";
import CullingReasons from "../../../services/UkTreatmentApi/CullingReasons";

export async function action({params}) {
    await CullingReasons.delete(params.cullingReasonId);

    return redirect(`/farms/${params.farmUid}/culling_reasons`);
}